import { A as s } from "./abort.js";
import { w as f } from "./withResolvers.js";
function y(...t) {
  return () => t.forEach((n) => n());
}
function w(t, n) {
  const r = { ...t };
  for (const e of n)
    delete r[e];
  return r;
}
function A(t, n) {
  const r = {};
  for (const e of n)
    e in t && (r[e] = t[e]);
  return r;
}
function v(t, n = 300) {
  let r, e;
  return { debounce: c, abort: i };
  async function c(...a) {
    return i(), e = f(), r = setTimeout(
      () => t(...a).then(e == null ? void 0 : e.resolve, e == null ? void 0 : e.reject),
      n
    ), e.promise;
  }
  function i() {
    r && e && (clearTimeout(r), e.reject(new s("Abort async debounce")), r = void 0, e = void 0);
  }
}
function T(t, n = 300) {
  let r, e;
  return {
    call: i,
    flush: a,
    abort: o,
    isScheduled: c
  };
  function c() {
    return !!e;
  }
  function i(...u) {
    o(), e = () => t(...u), r = setTimeout(() => a(), n);
  }
  function a() {
    e == null || e(), o();
  }
  function o() {
    clearTimeout(r), e = void 0, r = void 0;
  }
}
async function h(t) {
  await new Promise((n) => setTimeout(n, t));
}
async function E(t, n) {
  const { resolve: r, reject: e, promise: c } = f(), i = setTimeout(a, n);
  return t.addEventListener("abort", o), c;
  function a() {
    clearTimeout(i), t.removeEventListener("abort", o), r();
  }
  function o() {
    clearTimeout(i), t.removeEventListener("abort", o), e(new s("Abort timeout"));
  }
}
function S(t) {
  let n;
  return (...r) => {
    cancelAnimationFrame(n), n = requestAnimationFrame(() => t(...r));
  };
}
function g(t, n) {
  const r = performance.now();
  let e, c = !1;
  function i(o) {
    c || (t(o), a(o));
  }
  function a(o) {
    const u = o - r, m = Math.round(u / n) * n, d = r + m + n - performance.now();
    e = setTimeout(() => requestAnimationFrame(i), d);
  }
  return a(r), () => {
    clearTimeout(e), c = !0;
  };
}
function F(t) {
  const n = crypto.getRandomValues(new Uint8Array(t));
  return Array.from(n).reduce((r, e) => `${r}${e.toString(16).padStart(2, "0")}`, "");
}
function k(t, n) {
  try {
    return JSON.parse(t);
  } catch {
    return n;
  }
}
export {
  T as a,
  E as b,
  y as c,
  S as d,
  k as e,
  F as g,
  w as o,
  A as p,
  g as s,
  v as u,
  h as w
};
//# sourceMappingURL=helpers.js.map
